import { render, staticRenderFns } from "./OrderFood.vue?vue&type=template&id=2723f447&scoped=true"
import script from "./OrderFood.vue?vue&type=script&lang=js"
export * from "./OrderFood.vue?vue&type=script&lang=js"
import style0 from "./OrderFood.vue?vue&type=style&index=0&id=2723f447&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2723f447",
  null
  
)

export default component.exports